import { FormGroup, FormControl, Validators } from '@angular/forms';
import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-task-part-modal',
  templateUrl: './task-part-modal.component.html',
  styleUrls: ['./task-part-modal.component.css']
})
export class TaskPartModalComponent implements OnInit {
  @Input() newTemplateName=""
  myForm;
  sources=["template","system","part","expression"]
  @Output() partSourceEvent = new EventEmitter<string>()
  @Output() closeModalRequest = new EventEmitter<string>()
  constructor() { }


  get f() {
    return this.myForm.controls
  }

  ngOnInit(): void {

    this.myForm = new FormGroup({
      source: new FormControl("", [Validators.required])
    });

  }
  form_submit() {
    this.partSourceEvent.emit(this.f.source.value)
    this.closeModal()
  }
  closeModal(){
     this.closeModalRequest.emit("myTaskPartModal")
  }
}
